import React, { useEffect, useState } from "react";
import {
  UncontrolledDropdown,
  Button,
  Row,
  Col,
  Spinner,
  Alert,
} from "reactstrap";
import { Modal } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { ReactTyped } from "react-typed";
import { FormProvider, useForm } from "react-hook-form";
import miscService from "../../../api/misc/misc";
import { Icon } from "../../../components/Component";
import FormInput from "../../form-components/InputComponent";
import { nanoid } from "nanoid";
import dayjs from "dayjs";
import purchaseRequestApis from "../../../api/master/purchaseRequest";
import quotationApis from "../../../api/master/quotations";
import deliveryAddressApis from "../../../api/master/deliveryAddress";
import ExportToXlsx from "../../../utils/exportToXlsx";
import purchaseOrderApis from "../../../api/master/PurchaseOrder";
import { TAX_SLAP_DROPDOWN } from "../../purchase-orders/EditPOMaterialModal";
import invoiceApis from "../../../api/Invoice/invoice";
import { uploadApis } from "../../../api/Uploads";
const blobUrl: String = process.env.REACT_APP_BLOB_URL || "";
const blobContainer: String = process.env.REACT_APP_BLOB_CONTAINER || "";
const Configuration: any = {
  "add-new-purchase-request": {
    title: "Bulk Material Upload",
    requestType: "purchaseRequestCreate",
  },
  "rfq-creation": {
    title: "Bulk Material Upload",
    requestType: "rfqCreation",
  },
  "po-creation": {
    title: "Bulk Material Upload",
    requestType: "poCreation",
  },
  "quot-material-list": {
    title: "Bulk Material Upload",
    requestType: "quotMaterialList",
  },
  "order-to-invoice": {
    title: "Bulk Material Upload",
    requestType: "orderToInvoice",
  },
};

const BulkMaterialUpload = ({
  moduleKey,
  append,
  extra,
  selectedSiteId: propSelectedSiteId,
}: {
  moduleKey?: any;
  append?: any;
  extra?: any;
  selectedSiteId?: string | null;
}) => {
  const [deliveryAddressList, setDeliveryAddressList] = useState([]);
  const [materials, setMaterials] = useState<any>([]);
  const [sites, setSites] = useState<any>([]);
  const [selectedSiteId, setSelectedSiteId] = useState<string | null>(
    propSelectedSiteId || null
  );
  console.log(selectedSiteId, "siteProp");
  const [siteReferences, setSiteReferences] = useState<any>(null);
  const [referenceDataMessage, setReferenceDataMessage] = useState<{
    show: boolean;
    text: string;
  } | null>(null);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [blockEdit, setBlockEdit] = useState(false);
  const [response, setResponse] = useState({
    status: "",
    message: "",
  });

  const methods = useForm({
    mode: "onChange",
  });
  const {
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
  } = methods;
  const files = watch("attachment");

  useEffect(() => {
    setResponse({ status: "", message: "" });
  }, [files]);

  const [showModal, setShowModal] = useState(false);
  const fetchDeliveryAddress = async () => {
    try {
      const { data, status } = await deliveryAddressApis.fetchDeliveryAddress();
      if (status) {
        let deliveryAddressOptions = data.map((address: any) => {
          const {
            id,
            deliveryLocationName,
            city,
            addressLine1,
            addressLine2,
            pincode,
            countryName,
            stateName,
            districtName,
          } = address;
          return {
            Id: id,
            deliveryLocationName,
            addressLine1,
            addressLine2,
            city,
            districtName,
            stateName,
            countryName,
            pincode,
          };
        });

        setDeliveryAddressList(deliveryAddressOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchSiteList = async () => {
    try {
      const { data, status } = await miscService.fetchSitesFiltered();
      if (status) {
        const siteOption = data.map((item: any) => ({
          siteName: item?.name,
          siteId: item?.siteID?.toString(),
        }));
        setSites(siteOption);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchMaterialList = async () => {
    try {
      const { data, status } = await miscService.fetchProductFiltered();
      if (status) {
        const materialOption = data.map((item: any) => ({
          "Category Name": item?.categoryName,
          materialName: item?.productName,
          materialId: item?.materialID?.toString(),
        }));
        setMaterials(materialOption);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchSiteReferences = async (
    siteIds: string | string[],
    dependencies?: string | string[]
  ): Promise<any[]> => {
    try {
      // Only call API if both siteIds and dependencies are present
      if (!siteIds || !dependencies) {
        return [];
      }

      const siteParam = Array.isArray(siteIds) ? siteIds.join(",") : siteIds;
      // console.log("Fetching all references for sites:", siteParam);

      const response = await uploadApis.fetchProcurementReferences(
        siteParam,
        dependencies
      );
      // console.log("API Response:", response);

      const data =
        Array.isArray(response) && response.length > 0
          ? response
          : response && typeof response === "object" && !Array.isArray(response)
            ? [response]
            : [];

      setSiteReferences(data);
      return data;
    } catch (error) {
      setSiteReferences([]);
      return [];
    }
  };

  // Function to generate site structure reference data from ALL sites
  const generateSiteStructureReference = (refs?: any[]) => {
    const refsToUse = refs ?? siteReferences;
    if (!refsToUse || !Array.isArray(refsToUse)) return [];

    const structureData: any[] = [];

    refsToUse.forEach((site: any) => {
      // Filter by selectedSiteId if set
      if (
        selectedSiteId &&
        site.siteId?.toString() !== selectedSiteId &&
        site.id?.toString() !== selectedSiteId
      ) {
        return;
      }
      if (site?.siteStructures && Array.isArray(site.siteStructures)) {
        site.siteStructures.forEach((structure: any) => {
          if (structure?.units && Array.isArray(structure.units)) {
            structure.units.forEach((unit: any) => {
              if (unit?.subUnits && Array.isArray(unit.subUnits)) {
                unit.subUnits.forEach((subUnit: any) => {
                  structureData.push({
                    siteName: site.name,
                    projectName: structure.projectName || "",
                    unitId: unit.id || "",
                    unitName: unit.unitName || "",
                    subUnitId: subUnit.id || "",
                    subUnitName: subUnit.subUnitName || "",
                    floorNo: subUnit.floorNo || "",
                    floorType: subUnit.floorType || "",
                  });
                });
              }
            });
          }
        });
      }
    });

    return structureData;
  };

  // Function to generate locations reference data from ALL sites
  const generateLocationsReference = (refs?: any[]) => {
    try {
      const refsToUse = refs ?? siteReferences;
      if (!refsToUse || !Array.isArray(refsToUse)) {
        return [];
      }

      const allLocations: any[] = [];

      refsToUse.forEach((site: any) => {
        // Filter by selectedSiteId if set
        if (
          selectedSiteId &&
          site.siteId?.toString() !== selectedSiteId &&
          site.id?.toString() !== selectedSiteId
        ) {
          return;
        }
        if (site?.siteStructures && Array.isArray(site.siteStructures)) {
          site.siteStructures.forEach((structure: any) => {
            if (structure && Array.isArray(structure.locations)) {
              structure.locations.forEach((location: any) => {
                if (location && location.id && location.locationName) {
                  allLocations.push({
                    id: location.id,
                    locationName: location.locationName,
                    siteName: site.name,
                  });
                }
              });
            }
          });
        }
      });

      // console.log("Generated locations reference:", allLocations);
      return allLocations;
    } catch (error) {
      // console.error("Error generating locations reference:", error);
      return [];
    }
  };

  // Function to generate delivery addresses reference data from ALL sites
  const generateDeliveryAddressesReference = (refs?: any[]) => {
    const refsToUse = refs ?? siteReferences;
    if (!refsToUse || !Array.isArray(refsToUse)) return [];

    const allAddresses: any[] = [];
    refsToUse.forEach((site: any) => {
      if (site?.deliveryAddresses && Array.isArray(site.deliveryAddresses)) {
        site.deliveryAddresses.forEach((address: any) => {
          allAddresses.push({
            id: address.id,
            deliveryLocationName: address.deliveryLocationName,
            addressLine1: address.addressLine1,
            addressLine2: address.addressLine2,
            city: address.city,
            pincode: address.pincode,
            districtName: address.districtName,
            stateName: address.stateName,
            countryName: address.countryName,
            siteName: site.name,
          });
        });
      }
    });

    return allAddresses;
  };

  // Guard: export reference data only if non-empty; show message if data not ready
  const exportReferenceData = (
    data: any[] | null | undefined,
    fileName: string
  ) => {
    if (!data || !Array.isArray(data) || data.length === 0) {
      setReferenceDataMessage({
        show: true,
        text: "Reference data is not available yet. Please wait for the page to finish loading and try again.",
      });
      return;
    }
    setReferenceDataMessage(null);
    ExportToXlsx(data, fileName);
  };

  // Clear "reference data not available" message only when the user closes the modal
  useEffect(() => {
    if (!showModal) {
      setReferenceDataMessage(null);
    }
  }, [showModal]);

  useEffect(() => {
    fetchMaterialList();
    fetchDeliveryAddress();
    fetchSiteList();
  }, [moduleKey]);

  // Sync selectedSiteId from prop when it changes
  useEffect(() => {
    if (propSelectedSiteId) {
      setSelectedSiteId(propSelectedSiteId);
      // If a site is selected, fetch only references for that site
      if (moduleKey === "add-new-purchase-request" || moduleKey === "po-creation") {
        fetchSiteReferences(propSelectedSiteId);
      }
    }
  }, [propSelectedSiteId, moduleKey]);

  useEffect(() => {
    if (
      (moduleKey === "add-new-purchase-request" ||
        moduleKey === "po-creation") &&
      sites.length > 0 &&
      !propSelectedSiteId
    ) {
      // Only fetch all sites if no specific site is selected
      const siteIds = sites.map((site: any) => site.siteId);
      fetchSiteReferences(siteIds);
    }
    // For consumption-target-list, don't auto-fetch - let user click on site-specific links
  }, [sites, moduleKey, propSelectedSiteId]);

  const handleUpload = async () => {
    try {
      const attachment = files;
      if (!attachment || !attachment[0]) {
        setResponse({
          status: "error",
          message: "Please select a file",
        });
        setBlockEdit(false);
        setLoading(false);
        return;
      }
      uploadFile(
        attachment,
        moduleKey,
        setResponse,
        "File Uploaded Successfully"
      );
    } catch (error) { }
  };

  const uploadFile = async (
    attachment: any,
    moduleKey: string,
    setResponse: any,
    successResponse: any
  ) => {
    try {
      const _file = attachment?.[0];
      const formData: any = new FormData();
      formData.append("files", _file);
      let request: any;
      if (moduleKey == "po-creation") {
        request = {
          deliveryDateType: extra?.formData?.needByDateType || "Order Level",
          deliveryLevelType:
            extra?.formData?.deliveryAddressType || "Order Level",
          igstFlag: extra?.formData?.igstFlag,
          siteId: selectedSiteId ? parseInt(selectedSiteId.toString(), 10) : null,
        };
        let lines: any = [];
        extra?.fields?.forEach((item: any) => {
          let obj: {
            materialId: number;
            categoryId: number;
            quantity?: number;
            uomId?: number;
            deliveryDate?: any;
            deliveryAddressId?: Number;
            siteStructureUnitId?: any;
            siteStructureSubUnitId?: any;
          } = {
            materialId: Number(item?.materialName),
            categoryId: Number(item?.materialCategory),
            siteStructureUnitId: item?.siteStructureUnitId,
            siteStructureSubUnitId: item?.siteStructureSubUnitId,
          };
          if (item?.quantity) obj.quantity = Number(item?.quantity);
          if (item?.uomId) obj.uomId = Number(item?.uomId);
          if (extra?.formData?.deliveryAddressType == "Line Level")
            obj.deliveryAddressId = Number(item?.deliveryAddressId);

          if (extra?.formData?.needByDateType == "Line Level")
            obj.deliveryDate = dayjs(item?.needByDate).format("DD-MMM-YYYY");

          lines.push(obj);
        });
        request.lines = lines;
      } else if (moduleKey == "order-to-invoice") {
        request = extra;
      } else {
        request = {
          deliveryLevelType:
            extra?.formData?.deliveryAddressType || "ORDER_LEVEL",
          deliveryDateType: extra?.formData?.needByDateType || "ORDER_LEVEL",
          siteId: selectedSiteId ? parseInt(selectedSiteId.toString(), 10) : null,
        };
        let lines: any = [];
        extra?.fields?.forEach((item: any) => {
          let obj: {
            materialId: number;
            categoryId: number;
            quantity?: number;
            uomId?: number;
            deliveryDate?: any;
            deliveryAddressId?: Number;
          } = {
            materialId: Number(item?.materialName),
            categoryId: Number(item?.materialCategory),
          };
          if (item?.quantity) obj.quantity = Number(item?.quantity);
          if (item?.uomId) obj.uomId = Number(item?.uomId);
          if (extra?.formData?.deliveryAddressType == "LINE_LEVEL")
            obj.deliveryAddressId = Number(item?.deliveryAddressId);

          if (extra?.formData?.needByDateType == "LINE_LEVEL")
            obj.deliveryDate = dayjs(item?.needByDate).format("DD-MMM-YYYY");

          lines.push(obj);
        });
        request.lines = lines;
      }

      if (moduleKey == "quot-material-list") request = { ...extra };

      formData.append("request", JSON.stringify(request));
      let res;
      switch (moduleKey) {
        case "add-new-purchase-request":
          res = await purchaseRequestApis.materialBulkUploadCreate(formData);
          break;
        case "rfq-creation":
          res = await quotationApis.materialBulkUploadCreate(formData);
          break;
        case "po-creation":
          res = await purchaseOrderApis.orderMaterialBulkUpload(formData);
          break;
        case "order-to-invoice":
          res = await invoiceApis.bulkUploadInvoiceMaterials(formData);
          break;
        case "quot-material-list":
          res = await quotationApis.rfqPriceBulkUpload(formData);
          break;
        default:
      }
      const { status, error, message, response: data } = res || {};
      if (status) {
        setResponse({
          status: "success",
          message: successResponse,
        });
        if (moduleKey == "quot-material-list") {
          append({
            ...data,
          });
        } else if (moduleKey == "order-to-invoice") {
          append(data);
        } else if (moduleKey == "po-creation") {
          try {
            const { lines } = data || [];

            // Ensure we have site references to resolve unit/subunit names to IDs
            const refs = await fetchSiteReferences(
              selectedSiteId || (sites && sites.length ? sites.map((s: any) => s.siteId) : undefined),
              ["SITE_STRUCTURES", "LOCATIONS", "DELIVERY_ADDRESSES"]
            );

            const resolveStructureIds = (lineItem: any) => {
              if (!refs || !Array.isArray(refs) || refs.length === 0) return {};
              for (const site of refs) {
                if (
                  selectedSiteId &&
                  site.siteId?.toString() !== selectedSiteId &&
                  site.id?.toString() !== selectedSiteId
                ) {
                  continue;
                }
                if (!site.siteStructures || !Array.isArray(site.siteStructures)) continue;
                for (const structure of site.siteStructures) {
                  if (!structure.units || !Array.isArray(structure.units)) continue;
                  for (const unit of structure.units) {
                    const unitName = unit.unitName || unit.unitName?.toString();
                    if (lineItem?.unitName && unitName && unitName.toString().trim().toLowerCase() === lineItem.unitName.toString().trim().toLowerCase()) {
                      // if subUnitName provided, try to match subUnit
                      if (lineItem?.subUnitName && unit.subUnits && Array.isArray(unit.subUnits)) {
                        const matchedSub = unit.subUnits.find((su: any) => (su.subUnitName || "").toString().trim().toLowerCase() === lineItem.subUnitName.toString().trim().toLowerCase());
                        if (matchedSub) {
                          return { siteStructureUnitId: unit.id, siteStructureSubUnitId: matchedSub.id };
                        }
                      }
                      // no subUnit match required, return unit id
                      return { siteStructureUnitId: unit.id };
                    }
                  }
                }
              }
              return {};
            };
            lines?.forEach((line: any) => {
              const resolved = resolveStructureIds(line) || {};
              const igstValue = TAX_SLAP_DROPDOWN?.find(
                (dropdownItem) =>
                  dropdownItem?.label == line?.igstPercentage + "%"
              )?.value;
              const gst = TAX_SLAP_DROPDOWN?.find((dropdownItem) => {
                // console.log(Number(line?.cgstPercentage + line?.sgstPercentage)," == ", dropdownItem?.label);

                return (
                  dropdownItem?.label ==
                  Number(line?.cgstPercentage + line?.sgstPercentage) + "%"
                );
              })?.value;
              const sgstValue = gst;
              const cgstValue = gst;
              append({
                key: nanoid(),
                materialCategory: line?.categoryId?.toString(),
                materialName: line?.materialId?.toString(),
                materialLabel: line?.materialName,
                hsnCode: line?.hsnCode,
                quantity: line?.quantity,
                unitPrice: line?.unitPrice,
                uomId: line?.uomId,
                uomLabel: line?.uomName,
                amount:
                  Number(line?.unitPrice || 0) * Number(line?.quantity || 0),
                description: line?.description,
                igst: igstValue,
                igstPercentage: line?.igstPercentage,
                igstAmount: line?.igstAmount,
                cgst: cgstValue,
                cgstPercentage: line?.cgstPercentage,
                cgstAmount: line?.cgstAmount,
                sgst: sgstValue,
                sgstPercentage: line?.sgstPercentage,
                sgstAmount: line?.sgstAmount,
                cess: [],
                lineTotal: line?.lineTotal,
                attachment: false,
                errorMessage: line?.errorMessage,
                errorFlag: line?.errorFlag,
                needByDate: dayjs(line?.needByDate),
                // Hierarchy mapping
                siteStructureUnitId: line?.siteStructureUnitId ?? resolved.siteStructureUnitId ?? null,
                siteStructureSubUnitId: line?.siteStructureSubUnitId ?? resolved.siteStructureSubUnitId ?? null,
                // also set legacy/alternate fields used elsewhere
                towerBlockVillaId: (line?.siteStructureUnitId ?? resolved.siteStructureUnitId) ?? null,
                flatId: (line?.siteStructureSubUnitId ?? resolved.siteStructureSubUnitId) ?? null,
                towerBlockVillaLabel: line?.unitName,
                floorNo: line?.floorNo,
                flatLabel: line?.subUnitName,
                locationId: line?.locationId,
                locationLabel: line?.locationName,
              });
            });
          } catch (error) {
            console.log("error While creating PO", error);
          }
        } else {
          const { lines } = data || [];
          // Attempt to resolve any missing unit/subunit IDs from site references
          const refs = await fetchSiteReferences(
            selectedSiteId || (sites && sites.length ? sites.map((s: any) => s.siteId) : undefined),
            ["SITE_STRUCTURES", "LOCATIONS", "DELIVERY_ADDRESSES"]
          );

          const resolveStructureIdsForItem = (lineItem: any) => {
            if (!refs || !Array.isArray(refs) || refs.length === 0) return {};
            for (const site of refs) {
              if (
                selectedSiteId &&
                site.siteId?.toString() !== selectedSiteId &&
                site.id?.toString() !== selectedSiteId
              ) {
                continue;
              }
              if (!site.siteStructures || !Array.isArray(site.siteStructures)) continue;
              for (const structure of site.siteStructures) {
                if (!structure.units || !Array.isArray(structure.units)) continue;
                for (const unit of structure.units) {
                  const unitName = unit.unitName || unit.unitName?.toString();
                  if (lineItem?.unitName && unitName && unitName.toString().trim().toLowerCase() === lineItem.unitName.toString().trim().toLowerCase()) {
                    if (lineItem?.subUnitName && unit.subUnits && Array.isArray(unit.subUnits)) {
                      const matchedSub = unit.subUnits.find((su: any) => (su.subUnitName || "").toString().trim().toLowerCase() === lineItem.subUnitName.toString().trim().toLowerCase());
                      if (matchedSub) {
                        return { siteStructureUnitId: unit.id, siteStructureSubUnitId: matchedSub.id };
                      }
                    }
                    return { siteStructureUnitId: unit.id };
                  }
                }
              }
            }
            return {};
          };

          lines?.forEach((item: any) => {
            const resolved = resolveStructureIdsForItem(item) || {};
            const {
              materialId: materialName,
              materialName: materialLabel,
              categoryId: materialCategory,
              categoryName: categoryLabel,
              quantity,
              specification,
              errorFlag,
              errorMessage,
              remarks,
              uomId,
              uomName: uomLabel,
              floorNo,
              locationId,
              locationName,
              siteStructureSubUnitId,
              siteStructureUnitId,
              subUnitName,
              unitName
            } = item;
            let obj: any = {
              key: nanoid(),
              materialCategory,
              categoryLabel,
              materialName,
              materialLabel,
              quantity,
              specification,
              remarks,
              uomId,
              uomLabel,
              errorFlag,
              errorMessage,
              locationName,
              subUnitName,
              unitName,
              // Hierarchy mapping (resolve missing ids from refs)
              siteStructureUnitId: item?.siteStructureUnitId ?? resolved.siteStructureUnitId ?? null,
              siteStructureSubUnitId: item?.siteStructureSubUnitId ?? resolved.siteStructureSubUnitId ?? null,
              // also set legacy/alternate fields used elsewhere
              towerBlockVillaId: (item?.siteStructureUnitId ?? resolved.siteStructureUnitId) ?? null,
              flatId: (item?.siteStructureSubUnitId ?? resolved.siteStructureSubUnitId) ?? null,
              towerBlockVillaLabel: item?.unitName,
              floorNo: item?.floorNo,
              flatLabel: item?.subUnitName,
              locationId: item?.locationId,
              locationLabel: item?.locationName,
            };
            if (extra?.formData?.deliveryAddressType == "LINE_LEVEL")
              obj.deliveryAddressId = item?.deliveryAddressId;
            if (extra?.formData?.needByDateType == "LINE_LEVEL")
              obj.needByDate = dayjs(item?.deliveryDate);
            console.log("obj", obj);
            append(obj);
          });
        }
        return;
      }
      setResponse({
        status: "error",
        message: error + ": " + message,
      });
      setBlockEdit(false);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const ModalContent = ({ moduleKey }: any) => {
    switch (moduleKey) {
      case "order-to-invoice":
        return (
          <>
            <p>
              You're about to submit a invoice for multiple materials. To ensure
              a smooth import, please upload the file below.
            </p>

            <div className="text-right mt-3"></div>
            <p>
              <strong>Note : </strong> Do not modify column names or any
              existing data. All fields in the template are mandatory.
            </p>
            <Col md={4}>
              {files && files[0]?.name && (
                <div className="form-group m-0">
                  <div className="form-label-wrapper">
                    <label className="form-label" htmlFor={"attachment"}>
                      File Upload Area
                    </label>
                  </div>
                  <div
                    className="form-control-wrap d-flex align-items-center justify-content-between border p-1"
                    style={{ borderRadius: "3px" }}
                  >
                    <span>{files && files[0]?.name}</span>
                    {!blockEdit && (
                      <span
                        onClick={() => {
                          setValue("attachment", null);
                        }}
                        style={{
                          cursor: "pointer",
                          marginLeft: "10px",
                          display: "block",
                          fontSize: 14,
                        }}
                      >
                        <Icon name="cross"></Icon> &nbsp;
                      </span>
                    )}
                  </div>
                </div>
              )}
              <div
                style={{
                  display: `${files && files[0]?.name ? "none" : "block"}`,
                }}
              >
                <FormInput
                  type="file"
                  name="attachment"
                  label="File Upload Area"
                  placeholder="File Upload Area"
                  accept=".xlsx" // ,.xls,.csv
                />
              </div>
            </Col>
          </>
        );
      case "quot-material-list":
        return (
          <>
            <p>
              You're about to submit a quotation for multiple materials. To
              ensure a smooth import, please upload the file below.
            </p>

            <div className="text-right mt-3"></div>
            <p>
              <strong>Note : </strong> Do not modify column names or any
              existing data. All fields in the template are mandatory.
            </p>
            <Col md={4}>
              {files && files[0]?.name && (
                <div className="form-group m-0">
                  <div className="form-label-wrapper">
                    <label className="form-label" htmlFor={"attachment"}>
                      File Upload Area
                    </label>
                  </div>
                  <div
                    className="form-control-wrap d-flex align-items-center justify-content-between border p-1"
                    style={{ borderRadius: "3px" }}
                  >
                    <span>{files && files[0]?.name}</span>
                    {!blockEdit && (
                      <span
                        onClick={() => {
                          setValue("attachment", null);
                        }}
                        style={{
                          cursor: "pointer",
                          marginLeft: "10px",
                          display: "block",
                          fontSize: 14,
                        }}
                      >
                        <Icon name="cross"></Icon> &nbsp;
                      </span>
                    )}
                  </div>
                </div>
              )}
              <div
                style={{
                  display: `${files && files[0]?.name ? "none" : "block"}`,
                }}
              >
                <FormInput
                  type="file"
                  name="attachment"
                  label="File Upload Area"
                  placeholder="File Upload Area"
                  accept=".xlsx" // ,.xls,.csv
                />
              </div>
            </Col>
          </>
        );
      case "add-new-purchase-request":
        return (
          <>
            <div style={{ marginBottom: "12px" }}>
              <p>
                You're about to create multiple Lines of Materials at once. To
                ensure a smooth import, please{" "}
                <a
                  href={`${blobUrl}${blobContainer}/PR-Material-Bulk-Upload.xlsx#`}
                  target="_self"
                  style={{
                    textDecoration: "underline",
                  }}
                >
                  Download Template
                </a>{" "}
                and fill in the required supplier data accurately and completely,
                then upload the file below. you can check for reference
              </p>
            </div>

            {/* Reference Data Section */}
            <div
              style={{
                backgroundColor: "#f8f9fa",
                padding: "10px",
                borderRadius: "6px",
                marginBottom: "12px",
                border: "1px solid #e9ecef",
              }}
            >
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#495057",
                  marginBottom: "6px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Icon
                  name="info"
                  style={{
                    marginRight: "6px",
                    fontSize: "14px",
                    display: "inline-flex",
                    alignItems: "center",
                    lineHeight: "1",
                  }}
                />
                <span
                  style={{
                    lineHeight: "1",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                >
                  Reference Data
                </span>
              </div>
              <p
                style={{
                  fontSize: "12px",
                  color: "#6c757d",
                  marginBottom: "10px",
                }}
              >
                Download reference data for accurate data entry:{" "}
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    exportReferenceData(sites, "Sites");
                  }}
                  style={{
                    textDecoration: "none",
                    color: "#2263b3",
                    fontWeight: "600",
                    marginRight: "8px",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    transition: "all 0.2s ease",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#e7f1ff";
                    e.currentTarget.style.color = "#1a4d8c";
                    e.currentTarget.style.textDecoration = "underline";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "#2263b3";
                    e.currentTarget.style.textDecoration = "none";
                  }}
                >
                  <Icon name="file-text" style={{ marginRight: "4px" }} />
                  Sites
                </a>
                and{" "}
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    exportReferenceData(materials, "Materials");
                  }}
                  style={{
                    textDecoration: "none",
                    color: "#2263b3",
                    fontWeight: "600",
                    marginLeft: "4px",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    transition: "all 0.2s ease",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#e7f1ff";
                    e.currentTarget.style.color = "#1a4d8c";
                    e.currentTarget.style.textDecoration = "underline";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "#2263b3";
                    e.currentTarget.style.textDecoration = "none";
                  }}
                >
                  <Icon name="file-text" style={{ marginRight: "4px" }} />
                  Materials
                </a>
              </p>

              {/* Site-specific References - Show selected site only if provided */}
              {propSelectedSiteId ? (
                <div style={{ marginTop: "10px" }}>
                  <div
                    style={{
                      fontSize: "11px",
                      fontWeight: "600",
                      color: "#495057",
                      marginBottom: "6px",
                    }}
                  >
                    Selected Site References:
                  </div>
                  {sites.length > 0 && (
                    <div
                      style={{
                        backgroundColor: "#fff",
                        padding: "8px",
                        borderRadius: "4px",
                        border: "1px solid #dee2e6",
                      }}
                    >
                      {(() => {
                        const selectedSite = sites.find(
                          (site: any) =>
                            site.siteId?.toString() ===
                            propSelectedSiteId?.toString()
                        );
                        return (
                          <>
                            <div
                              style={{
                                fontWeight: "600",
                                color: "#212529",
                                marginBottom: "8px",
                                fontSize: "12px",
                              }}
                            >
                              {selectedSite?.siteName || "Selected Site"}
                            </div>
                            <div
                              style={{
                                fontSize: "11px",
                                color: "#6c757d",
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "8px",
                              }}
                            >
                              <a
                                href="#"
                                onClick={async (e) => {
                                  e.preventDefault();
                                  const refs = await fetchSiteReferences(propSelectedSiteId, [
                                    "SITE_STRUCTURES",
                                    "LOCATIONS",
                                    "DELIVERY_ADDRESSES",
                                  ]);
                                  exportReferenceData(
                                    generateSiteStructureReference(refs),
                                    `${selectedSite?.siteName}_Site_Structures`
                                  );
                                }}
                                style={{
                                  textDecoration: "none",
                                  color: "#2263b3",
                                  fontSize: "11px",
                                  padding: "4px 8px",
                                  borderRadius: "3px",
                                  transition: "all 0.2s ease",
                                  cursor: "pointer",
                                  backgroundColor: "#e7f1ff",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    "#d4e4ff";
                                  e.currentTarget.style.color = "#1a4d8c";
                                  e.currentTarget.style.textDecoration =
                                    "underline";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    "#e7f1ff";
                                  e.currentTarget.style.color = "#2263b3";
                                  e.currentTarget.style.textDecoration = "none";
                                }}
                              >
                                <Icon
                                  name="file-text"
                                  style={{ marginRight: "4px" }}
                                />
                                Site Structures
                              </a>
                              <a
                                href="#"
                                onClick={async (e) => {
                                  e.preventDefault();
                                  const refs = await fetchSiteReferences(propSelectedSiteId, [
                                    "SITE_STRUCTURES",
                                    "LOCATIONS",
                                    "DELIVERY_ADDRESSES",
                                  ]);
                                  exportReferenceData(
                                    generateLocationsReference(refs),
                                    `${selectedSite?.siteName}_Locations`
                                  );
                                }}
                                style={{
                                  textDecoration: "none",
                                  color: "#2263b3",
                                  fontSize: "11px",
                                  padding: "4px 8px",
                                  borderRadius: "3px",
                                  transition: "all 0.2s ease",
                                  cursor: "pointer",
                                  backgroundColor: "#e7f1ff",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    "#d4e4ff";
                                  e.currentTarget.style.color = "#1a4d8c";
                                  e.currentTarget.style.textDecoration =
                                    "underline";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    "#e7f1ff";
                                  e.currentTarget.style.color = "#2263b3";
                                  e.currentTarget.style.textDecoration = "none";
                                }}
                              >
                                <Icon
                                  name="file-text"
                                  style={{ marginRight: "4px" }}
                                />
                                Locations
                              </a>
                              <a
                                href="#"
                                onClick={async (e) => {
                                  e.preventDefault();
                                  const refs = await fetchSiteReferences(propSelectedSiteId, [
                                    "SITE_STRUCTURES",
                                    "LOCATIONS",
                                    "DELIVERY_ADDRESSES",
                                  ]);
                                  exportReferenceData(
                                    generateDeliveryAddressesReference(refs),
                                    `${selectedSite?.siteName}_Delivery_Addresses`
                                  );
                                }}
                                style={{
                                  textDecoration: "none",
                                  color: "#2263b3",
                                  fontSize: "11px",
                                  padding: "4px 8px",
                                  borderRadius: "3px",
                                  transition: "all 0.2s ease",
                                  cursor: "pointer",
                                  backgroundColor: "#e7f1ff",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    "#d4e4ff";
                                  e.currentTarget.style.color = "#1a4d8c";
                                  e.currentTarget.style.textDecoration =
                                    "underline";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    "#e7f1ff";
                                  e.currentTarget.style.color = "#2263b3";
                                  e.currentTarget.style.textDecoration = "none";
                                }}
                              >
                                <Icon
                                  name="file-text"
                                  style={{ marginRight: "4px" }}
                                />
                                Delivery Addresses
                              </a>
                            </div>
                          </>
                        );
                      })()}
                    </div>
                  )}
                </div>
              ) : (
                // Show all sites option when no specific site is pre-selected
                <div style={{ marginTop: "10px" }}>
                  <div
                    style={{
                      fontSize: "11px",
                      fontWeight: "600",
                      color: "#495057",
                      marginBottom: "6px",
                    }}
                  >
                    Site-Specific References:
                  </div>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(3, 1fr)",
                      gap: "6px",
                      maxHeight: "150px",
                      overflowY: "auto",
                      padding: "4px",
                    }}
                  >
                    {sites.map((site: any) => (
                      <div
                        key={site.siteId}
                        style={{
                          backgroundColor: "#fff",
                          padding: "6px",
                          borderRadius: "4px",
                          border: "1px solid #dee2e6",
                          transition: "box-shadow 0.2s",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.boxShadow =
                            "0 2px 4px rgba(0,0,0,0.1)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.boxShadow = "none";
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "600",
                            color: "#212529",
                            marginBottom: "4px",
                            fontSize: "12px",
                          }}
                        >
                          {site.siteName}
                        </div>
                        <div
                          style={{
                            fontSize: "11px",
                            color: "#6c757d",
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "4px",
                          }}
                        >
                          <a
                            href="#"
                            onClick={async (e) => {
                              e.preventDefault();
                              await fetchSiteReferences(site.siteId, [
                                "SITE_STRUCTURES",
                              ]);
                              setSelectedSiteId(
                                site.siteId?.toString() || site.siteId
                              );
                              exportReferenceData(
                                generateSiteStructureReference(),
                                `${site.siteName}_Site_Structures`
                              );
                            }}
                            style={{
                              textDecoration: "none",
                              color: "#2263b3",
                              fontSize: "11px",
                              padding: "2px 6px",
                              borderRadius: "3px",
                              transition: "all 0.2s ease",
                              cursor: "pointer",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "#e7f1ff";
                              e.currentTarget.style.color = "#1a4d8c";
                              e.currentTarget.style.textDecoration =
                                "underline";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                "transparent";
                              e.currentTarget.style.color = "#2263b3";
                              e.currentTarget.style.textDecoration = "none";
                            }}
                          >
                            Site Structures
                          </a>
                          <span style={{ color: "#dee2e6" }}>|</span>
                          <a
                            href="#"
                            onClick={async (e) => {
                              e.preventDefault();
                              await fetchSiteReferences(site.siteId, [
                                "LOCATIONS",
                              ]);
                              setSelectedSiteId(
                                site.siteId?.toString() || site.siteId
                              );
                              exportReferenceData(
                                generateLocationsReference(),
                                `${site.siteName}_Locations`
                              );
                            }}
                            style={{
                              textDecoration: "none",
                              color: "#2263b3",
                              fontSize: "11px",
                              padding: "2px 6px",
                              borderRadius: "3px",
                              transition: "all 0.2s ease",
                              cursor: "pointer",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "#e7f1ff";
                              e.currentTarget.style.color = "#1a4d8c";
                              e.currentTarget.style.textDecoration =
                                "underline";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                "transparent";
                              e.currentTarget.style.color = "#2263b3";
                              e.currentTarget.style.textDecoration = "none";
                            }}
                          >
                            Locations
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div className="text-right mt-3"></div>
            <p>
              <strong>Note : </strong>
              All fields in the template are mandatory. Each record must have
              unique information to avoid errors during the import process.
            </p>
            <Col md={4}>
              {files && files[0]?.name && (
                <div className="form-group m-0">
                  <div className="form-label-wrapper">
                    <label className="form-label" htmlFor={"attachment"}>
                      File Upload Area
                    </label>
                  </div>
                  <div
                    className="form-control-wrap d-flex align-items-center justify-content-between border p-1"
                    style={{ borderRadius: "3px" }}
                  >
                    <span>{files && files[0]?.name}</span>
                    {!blockEdit && (
                      <span
                        onClick={() => {
                          setValue("attachment", null);
                        }}
                        style={{
                          cursor: "pointer",
                          marginLeft: "10px",
                          display: "block",
                          fontSize: 14,
                        }}
                      >
                        <Icon name="cross"></Icon> &nbsp;
                      </span>
                    )}
                  </div>
                </div>
              )}
              <div
                style={{
                  display: `${files && files[0]?.name ? "none" : "block"}`,
                }}
              >
                <FormInput
                  type="file"
                  name="attachment"
                  label="File Upload Area"
                  placeholder="File Upload Area"
                  accept=".xlsx" // ,.xls,.csv
                />
              </div>
            </Col>
          </>
        );
      case "rfq-creation":
        const { deliveryAddressType, needByDateType } = extra?.formData;

        let url = `${blobUrl}${blobContainer}/RFQBulkUpload.xlsx`;
        if (deliveryAddressType == "LINE_LEVEL") {
          url = `${blobUrl}${blobContainer}/RFQBulkUploadWithID.xlsx`;
        }
        if (needByDateType == "LINE_LEVEL") {
          url = `${blobUrl}${blobContainer}/RFQBulkUploadWithDate.xlsx`;
        }
        if (
          deliveryAddressType == "LINE_LEVEL" &&
          needByDateType == "LINE_LEVEL"
        ) {
          url = `${blobUrl}${blobContainer}/RFQBulkUploadWithDateAndID.xlsx`;
        }

        return (
          <>
            <p>
              You're about to create multiple supplier records at once. To
              ensure a smooth import, please{" "}
              <a
                href={url}
                target="_self"
                style={{
                  textDecoration: "underline",
                }}
              >
                Download Template
              </a>{" "}
              and fill in the required supplier data accurately and completely,
              then upload the file below. you can check{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  exportReferenceData(deliveryAddressList, "Addresses");
                }}
                target="_self"
                style={{ textDecoration: "underline" }}
              >
                Addresses List
              </a>{" "}
              and{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  exportReferenceData(materials, "Materials");
                }}
                target="_self"
                style={{ textDecoration: "underline" }}
              >
                Materials
              </a>{" "}
              for reference
            </p>

            <div className="text-right mt-3"></div>
            <p>
              <strong>Note : </strong>
              All fields in the template are mandatory. Each record must have
              unique information to avoid errors during the import process.
            </p>
            <Col md={4}>
              {files && files[0]?.name && (
                <div className="form-group m-0">
                  <div className="form-label-wrapper">
                    <label className="form-label" htmlFor={"attachment"}>
                      File Upload Area
                    </label>
                  </div>
                  <div
                    className="form-control-wrap d-flex align-items-center justify-content-between border p-1"
                    style={{ borderRadius: "3px" }}
                  >
                    <span>{files && files[0]?.name}</span>
                    {!blockEdit && (
                      <span
                        onClick={() => {
                          setValue("attachment", null);
                        }}
                        style={{
                          cursor: "pointer",
                          marginLeft: "10px",
                          display: "block",
                          fontSize: 14,
                        }}
                      >
                        <Icon name="cross"></Icon> &nbsp;
                      </span>
                    )}
                  </div>
                </div>
              )}
              <div
                style={{
                  display: `${files && files[0]?.name ? "none" : "block"}`,
                }}
              >
                <FormInput
                  type="file"
                  name="attachment"
                  label="File Upload Area"
                  placeholder="File Upload Area"
                  accept=".xlsx" // ,.xls,.csv
                />
              </div>
            </Col>
          </>
        );
      case "po-creation":
        const {
          deliveryAddressType: _deliveryAddressType,
          needByDateType: _needByDateType,
          igstFlag: _hasIgst,
        } = extra?.formData;

        let _url = `${blobUrl}${blobContainer}/POUpload.xlsx`;
        if (_hasIgst) _url = `${blobUrl}${blobContainer}/POUploadWithIgst.xlsx`;

        if (_deliveryAddressType == "Line Level" && !_hasIgst)
          _url = `${blobUrl}${blobContainer}/POUploadMulitpleAddress.xlsx`;

        if (_deliveryAddressType == "Line Level" && _hasIgst)
          _url = `${blobUrl}${blobContainer}/POUploadMultipleAddressWithIgst.xlsx`;

        if (_needByDateType == "Line Level" && !_hasIgst)
          _url = `${blobUrl}${blobContainer}/POUploadMultipleDates.xlsx`;

        if (_needByDateType == "Line Level" && _hasIgst)
          _url = `${blobUrl}${blobContainer}/POUploadMultipleDatesWithIgst.xlsx`;

        if (
          _deliveryAddressType == "Line Level" &&
          _needByDateType == "Line Level" &&
          !_hasIgst
        )
          _url = `${blobUrl}${blobContainer}/POUploadMultipleDatesAddress.xlsx`;

        if (
          _deliveryAddressType == "Line Level" &&
          _needByDateType == "Line Level" &&
          _hasIgst
        )
          _url = `${blobUrl}${blobContainer}/POUploadMultipleDatesAddressWithIgst.xlsx`;
        return (
          <>
            <div style={{ marginBottom: "12px" }}>

              <p>
                You're about to create multiple Lines of Materials at once. To
                ensure a smooth import, please{" "}
                <a
                  href={_url}
                  target="_self"
                  style={{
                    textDecoration: "underline",
                  }}
                >
                  Download Template
                </a>{" "}
                and fill in the required supplier data accurately and completely,
                then upload the file below. you can check for reference
              </p>
            </div>

            {/* Reference Data Section */}
            <div
              style={{
                backgroundColor: "#f8f9fa",
                padding: "10px",
                borderRadius: "6px",
                marginBottom: "12px",
                border: "1px solid #e9ecef",
              }}
            >
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#495057",
                  marginBottom: "6px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Icon
                  name="info"
                  style={{
                    marginRight: "6px",
                    fontSize: "14px",
                    display: "inline-flex",
                    alignItems: "center",
                    lineHeight: "1",
                  }}
                />
                <span
                  style={{
                    lineHeight: "1",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                >
                  Reference Data
                </span>
              </div>
              <p
                style={{
                  fontSize: "12px",
                  color: "#6c757d",
                  marginBottom: "10px",
                }}
              >
                Download reference data for accurate data entry:{" "}
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    exportReferenceData(sites, "Sites");
                  }}
                  style={{
                    textDecoration: "none",
                    color: "#2263b3",
                    fontWeight: "600",
                    marginRight: "8px",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    transition: "all 0.2s ease",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#e7f1ff";
                    e.currentTarget.style.color = "#1a4d8c";
                    e.currentTarget.style.textDecoration = "underline";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "#2263b3";
                    e.currentTarget.style.textDecoration = "none";
                  }}
                >
                  <Icon name="file-text" style={{ marginRight: "4px" }} />
                  Sites
                </a>
                and{" "}
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    exportReferenceData(materials, "Materials");
                  }}
                  style={{
                    textDecoration: "none",
                    color: "#2263b3",
                    fontWeight: "600",
                    marginLeft: "4px",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    transition: "all 0.2s ease",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#e7f1ff";
                    e.currentTarget.style.color = "#1a4d8c";
                    e.currentTarget.style.textDecoration = "underline";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "#2263b3";
                    e.currentTarget.style.textDecoration = "none";
                  }}
                >
                  <Icon name="file-text" style={{ marginRight: "4px" }} />
                  Materials
                </a>
              </p>

              {/* Site-specific References - Show selected site only if provided */}
              {propSelectedSiteId ? (
                <div style={{ marginTop: "10px" }}>
                  <div
                    style={{
                      fontSize: "11px",
                      fontWeight: "600",
                      color: "#495057",
                      marginBottom: "6px",
                    }}
                  >
                    Selected Site References:
                  </div>
                  {sites.length > 0 && (
                    <div
                      style={{
                        backgroundColor: "#fff",
                        padding: "8px",
                        borderRadius: "4px",
                        border: "1px solid #dee2e6",
                      }}
                    >
                      {(() => {
                        const selectedSite = sites.find(
                          (site: any) =>
                            site.siteId?.toString() ===
                            propSelectedSiteId?.toString()
                        );
                        return (
                          <>
                            <div
                              style={{
                                fontWeight: "600",
                                color: "#212529",
                                marginBottom: "8px",
                                fontSize: "12px",
                              }}
                            >
                              {selectedSite?.siteName || "Selected Site"}
                            </div>
                            <div
                              style={{
                                fontSize: "11px",
                                color: "#6c757d",
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "8px",
                              }}
                            >
                              <a
                                href="#"
                                onClick={async (e) => {
                                  e.preventDefault();
                                  const refs = await fetchSiteReferences(propSelectedSiteId, [
                                    "SITE_STRUCTURES",
                                    "LOCATIONS",
                                    "DELIVERY_ADDRESSES",
                                  ]);
                                  exportReferenceData(
                                    generateSiteStructureReference(refs),
                                    `${selectedSite?.siteName}_Site_Structures`
                                  );
                                }}
                                style={{
                                  textDecoration: "none",
                                  color: "#2263b3",
                                  fontSize: "11px",
                                  padding: "4px 8px",
                                  borderRadius: "3px",
                                  transition: "all 0.2s ease",
                                  cursor: "pointer",
                                  backgroundColor: "#e7f1ff",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    "#d4e4ff";
                                  e.currentTarget.style.color = "#1a4d8c";
                                  e.currentTarget.style.textDecoration =
                                    "underline";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    "#e7f1ff";
                                  e.currentTarget.style.color = "#2263b3";
                                  e.currentTarget.style.textDecoration = "none";
                                }}
                              >
                                <Icon
                                  name="file-text"
                                  style={{ marginRight: "4px" }}
                                />
                                Site Structures
                              </a>
                              <a
                                href="#"
                                onClick={async (e) => {
                                  e.preventDefault();
                                  const refs = await fetchSiteReferences(propSelectedSiteId, [
                                    "SITE_STRUCTURES",
                                    "LOCATIONS",
                                    "DELIVERY_ADDRESSES",
                                  ]);
                                  exportReferenceData(
                                    generateLocationsReference(refs),
                                    `${selectedSite?.siteName}_Locations`
                                  );
                                }}
                                style={{
                                  textDecoration: "none",
                                  color: "#2263b3",
                                  fontSize: "11px",
                                  padding: "4px 8px",
                                  borderRadius: "3px",
                                  transition: "all 0.2s ease",
                                  cursor: "pointer",
                                  backgroundColor: "#e7f1ff",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    "#d4e4ff";
                                  e.currentTarget.style.color = "#1a4d8c";
                                  e.currentTarget.style.textDecoration =
                                    "underline";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    "#e7f1ff";
                                  e.currentTarget.style.color = "#2263b3";
                                  e.currentTarget.style.textDecoration = "none";
                                }}
                              >
                                <Icon
                                  name="file-text"
                                  style={{ marginRight: "4px" }}
                                />
                                Locations
                              </a>
                              <a
                                href="#"
                                onClick={async (e) => {
                                  e.preventDefault();
                                  const refs = await fetchSiteReferences(propSelectedSiteId, [
                                    "SITE_STRUCTURES",
                                    "LOCATIONS",
                                    "DELIVERY_ADDRESSES",
                                  ]);
                                  exportReferenceData(
                                    generateDeliveryAddressesReference(refs),
                                    `${selectedSite?.siteName}_Delivery_Addresses`
                                  );
                                }}
                                style={{
                                  textDecoration: "none",
                                  color: "#2263b3",
                                  fontSize: "11px",
                                  padding: "4px 8px",
                                  borderRadius: "3px",
                                  transition: "all 0.2s ease",
                                  cursor: "pointer",
                                  backgroundColor: "#e7f1ff",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    "#d4e4ff";
                                  e.currentTarget.style.color = "#1a4d8c";
                                  e.currentTarget.style.textDecoration =
                                    "underline";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    "#e7f1ff";
                                  e.currentTarget.style.color = "#2263b3";
                                  e.currentTarget.style.textDecoration = "none";
                                }}
                              >
                                <Icon
                                  name="file-text"
                                  style={{ marginRight: "4px" }}
                                />
                                Delivery Addresses
                              </a>
                            </div>
                          </>
                        );
                      })()}
                    </div>
                  )}
                </div>
              ) : (
                // Show all sites option when no specific site is pre-selected
                <div style={{ marginTop: "10px" }}>
                  <div
                    style={{
                      fontSize: "11px",
                      fontWeight: "600",
                      color: "#495057",
                      marginBottom: "6px",
                    }}
                  >
                    Site-Specific References:
                  </div>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(3, 1fr)",
                      gap: "6px",
                      maxHeight: "150px",
                      overflowY: "auto",
                      padding: "4px",
                    }}
                  >
                    {sites.map((site: any) => (
                      <div
                        key={site.siteId}
                        style={{
                          backgroundColor: "#fff",
                          padding: "6px",
                          borderRadius: "4px",
                          border: "1px solid #dee2e6",
                          transition: "box-shadow 0.2s",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.boxShadow =
                            "0 2px 4px rgba(0,0,0,0.1)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.boxShadow = "none";
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "600",
                            color: "#212529",
                            marginBottom: "4px",
                            fontSize: "12px",
                          }}
                        >
                          {site.siteName}
                        </div>
                        <div
                          style={{
                            fontSize: "11px",
                            color: "#6c757d",
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "4px",
                          }}
                        >
                          <a
                            href="#"
                            onClick={async (e) => {
                              e.preventDefault();
                              await fetchSiteReferences(site.siteId, [
                                "SITE_STRUCTURES",
                              ]);
                              setSelectedSiteId(
                                site.siteId?.toString() || site.siteId
                              );
                              exportReferenceData(
                                generateSiteStructureReference(),
                                `${site.siteName}_Site_Structures`
                              );
                            }}
                            style={{
                              textDecoration: "none",
                              color: "#2263b3",
                              fontSize: "11px",
                              padding: "2px 6px",
                              borderRadius: "3px",
                              transition: "all 0.2s ease",
                              cursor: "pointer",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "#e7f1ff";
                              e.currentTarget.style.color = "#1a4d8c";
                              e.currentTarget.style.textDecoration =
                                "underline";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                "transparent";
                              e.currentTarget.style.color = "#2263b3";
                              e.currentTarget.style.textDecoration = "none";
                            }}
                          >
                            Site Structures
                          </a>
                          <span style={{ color: "#dee2e6" }}>|</span>
                          <a
                            href="#"
                            onClick={async (e) => {
                              e.preventDefault();
                              await fetchSiteReferences(site.siteId, [
                                "LOCATIONS",
                              ]);
                              setSelectedSiteId(
                                site.siteId?.toString() || site.siteId
                              );
                              exportReferenceData(
                                generateLocationsReference(),
                                `${site.siteName}_Locations`
                              );
                            }}
                            style={{
                              textDecoration: "none",
                              color: "#2263b3",
                              fontSize: "11px",
                              padding: "2px 6px",
                              borderRadius: "3px",
                              transition: "all 0.2s ease",
                              cursor: "pointer",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "#e7f1ff";
                              e.currentTarget.style.color = "#1a4d8c";
                              e.currentTarget.style.textDecoration =
                                "underline";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                "transparent";
                              e.currentTarget.style.color = "#2263b3";
                              e.currentTarget.style.textDecoration = "none";
                            }}
                          >
                            Locations
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div className="text-right mt-3"></div>
            <p>
              <strong>Note : </strong> All fields in the template are mandatory.
              Each record must have unique information to avoid errors during
              the import process.
            </p>
            <Col md={4}>
              {files && files[0]?.name && (
                <div className="form-group m-0">
                  <div className="form-label-wrapper">
                    <label className="form-label" htmlFor={"attachment"}>
                      File Upload Area
                    </label>
                  </div>
                  <div
                    className="form-control-wrap d-flex align-items-center justify-content-between border p-1"
                    style={{ borderRadius: "3px" }}
                  >
                    <span>{files && files[0]?.name}</span>
                    {!blockEdit && (
                      <span
                        onClick={() => {
                          setValue("attachment", null);
                        }}
                        style={{
                          cursor: "pointer",
                          marginLeft: "10px",
                          display: "block",
                          fontSize: 14,
                        }}
                      >
                        <Icon name="cross"></Icon> &nbsp;
                      </span>
                    )}
                  </div>
                </div>
              )}
              <div
                style={{
                  display: `${files && files[0]?.name ? "none" : "block"}`,
                }}
              >
                <FormInput
                  type="file"
                  name="attachment"
                  label="File Upload Area"
                  placeholder="File Upload Area"
                  accept=".xlsx" // ,.xls,.csv
                />
              </div>
            </Col>
          </>
        );
      default:
        <></>;
    }
    return <></>;
  };

  return (
    <>
      <UncontrolledDropdown size={"md"}>
        {" "}
        <div
          onClick={() => {
            setShowModal(true);
          }}
          className="btn btn-white btn-outline-light"
        >
          <Icon name="upload-cloud"></Icon>
          <span>Import</span>
        </div>
      </UncontrolledDropdown>

      <Modal
        title={Configuration[moduleKey]?.title}
        open={showModal}
        footer={null}
        onCancel={() => {
          setShowModal(false);
          setReferenceDataMessage(null);
          // methods.reset()
          setValue("attachment", null);
          setLoading(false);
          setResponse(() => ({
            status: "",
            message: "",
          }));
        }}
        width={"60%"}
      >
        <FormProvider {...methods}>
          <form>
            {referenceDataMessage?.show && (
              <Alert
                color="info"
                className="d-flex align-items-center py-2 mt-2 mb-2"
                style={{ fontSize: "14px" }}
              >
                <Spinner size="sm" className="me-2" />
                {referenceDataMessage.text}
              </Alert>
            )}
            <ModalContent moduleKey={moduleKey} />
            <Alert
              isOpen={response?.status === "error"}
              color="danger"
              className="start-0 w-100 py-1 mt-2"
              style={{
                top: 0,
                textAlign: "left",
                fontSize: "14px",
                cursor: "default",
              }}
            >
              <ReactTyped
                strings={[response?.message]}
                typeSpeed={30}
                showCursor={false}
              />
            </Alert>

            <Alert
              isOpen={response?.status === "success"}
              color="success"
              className="start-0 w-100 py-1 mt-2"
              style={{
                top: 0,
                textAlign: "left",
                fontSize: "14px",
                cursor: "default",
              }}
            >
              <p>
                {response?.message}, You can{" "}
                <span
                  className="inlineTableCellLink"
                  onClick={() => {
                    setShowModal(false);
                    setBlockEdit(false);
                    // methods.reset();
                    setValue("attachment", null);
                    setLoading(false);
                    setResponse(() => ({
                      status: "",
                      message: "",
                    }));
                  }}
                >
                  close
                </span>{" "}
                this popup
              </p>
            </Alert>

            <Row className="mt-4">
              <Col>
                {response?.status == "success" ? (
                  <></>
                ) : (
                  <ul className="actions clearfix d-flex">
                    <li>
                      {loading ? (
                        <Button color="primary" type="button" size="md">
                          <Spinner size="sm" color="light" />
                        </Button>
                      ) : (
                        <Button
                          color="primary"
                          type="button"
                          disabled={!files?.[0]}
                          onClick={() => {
                            setResponse(() => ({
                              status: "",
                              message: "",
                            }));
                            setBlockEdit(true);
                            setLoading(true);
                            handleUpload();
                          }}
                        >
                          Upload
                        </Button>
                      )}
                    </li>
                    {!loading && (
                      <li className="m-3 mt-0">
                        <Button
                          color="primary"
                          onClick={() => {
                            setShowModal(false);
                            setReferenceDataMessage(null);
                            // methods.reset();
                            setValue("attachment", null);
                          }}
                          className="btn-dim btn btn-secondary"
                        >
                          Cancel
                        </Button>
                      </li>
                    )}
                  </ul>
                )}
              </Col>
            </Row>
          </form>
        </FormProvider>
      </Modal>
    </>
  );
};

export default BulkMaterialUpload;
